export default __webpack_public_path__ + "static/media/structure-wtp.50996131.svg";